import {
  LoaderCircleIcon_default
} from "./chunk-MKV5NJ7N.mjs";
export {
  LoaderCircleIcon_default as default
};
